export default {
  EXPORTAR_ARCHIVOS: 'EXPORTAR_ARCHIVOS'
}